import React from 'react'

export const secondToTimestrings = s => {
  let dateObj = new Date(s * 1000);
  let hours = dateObj.getUTCHours();
  let minutes = dateObj.getUTCMinutes();
  let seconds = dateObj.getSeconds();

  let timeString = hours.toString().padStart(2, '0') + ':' +
  minutes.toString().padStart(2, '0') + ':' +
  seconds.toString().padStart(2, '0');
  return timeString;
}

export const deadlineToDate = endtime => {
  var t = Date.parse(endtime) - Date.parse(new Date());
  var seconds = Math.floor( (t/1000) % 60 );
  var minutes = Math.floor( (t/1000/60) % 60 );
  var hours = Math.floor( (t/(1000*60*60)) % 24 );
  var days = Math.floor( t/(1000*60*60*24) );
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

export const timerCountdown = (endtime) => {
  let reminder;
  if( deadlineToDate(endtime).days > 0 ){
    reminder = `(${deadlineToDate(endtime).days} hari lagi)`
  } else if (
    deadlineToDate(endtime).hours > 0 &&
    deadlineToDate(endtime).days === 0) {
    reminder = `(${deadlineToDate(endtime).hours} jam lagi)`
  } else if (
    deadlineToDate(endtime).days === 0 &&
    deadlineToDate(endtime).hours === 0 &&
    deadlineToDate(endtime).minutes > 0) {
    reminder = `(${deadlineToDate(endtime).minutes} menit lagi)`
  } else {
    reminder = `(Sudah Lewat)`
  }
  return reminder
}
